import * as React from 'react';
import { useSelector } from 'react-redux';
import { InlineText1, InlineText2, IconPhone16 } from '@cian/ui-kit';
import { checkFsk, getDiscountById } from '../../selectors';
import { IApplicationState } from '../../types/redux';
import { DiscountCard as DiscountCardComponent } from '../../components/DiscountCard';
import { PromoDescriptionModal } from '../../components/PromoDescriptionModal';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { getDisplayedNewBuildings } from './helpers';
import { trackOpenDiscount, trackShowPhone } from './tracking';
import { Call } from '../Call';

interface IDiscountCardProps {
  discountId: number;
}

export function DiscountCard({ discountId }: IDiscountCardProps) {
  const [isOpen, setModal] = React.useState(false);
  const discount = useSelector((state: IApplicationState) => getDiscountById(state, discountId));
  const isFsk = useSelector(checkFsk);

  const toggleDiscount = React.useCallback(() => {
    if (!isOpen && discount) {
      trackOpenDiscount(discount.promoType);
    }

    setModal(prevState => !prevState);
  }, [discount, isOpen]);

  if (!discount) {
    return null;
  }

  const displayedNewBuildings = getDisplayedNewBuildings(discount.newBuildings);

  return (
    <>
      <DiscountCardComponent
        name={<InlineText1 fontWeight="bold">{discount.name}</InlineText1>}
        authorName={<InlineText2 color="black_60">{discount.authorName}</InlineText2>}
        dueDate={<InlineText2 color="black_60">{discount.endLabel}</InlineText2>}
        displayedNewBuildings={<InlineText2>{displayedNewBuildings}</InlineText2>}
        promoType={discount.promoType}
        onClick={toggleDiscount}
      />
      <PromoDescriptionModal
        authorLabel="Акция от застройщика"
        open={isOpen}
        onClose={toggleDiscount}
        name={discount.name}
        description={discount.description}
        dueDate={discount.endLabel}
        authorName={discount.authorName}
        authorLogoUrl={discount.authorLogo}
        newBuildings={discount.newBuildings}
        callback={
          isFsk ? (
            <SPThemeWrapper theme={isFsk ? 'fsk_fill_primary' : undefined}>
              <Call
                onShowPhone={trackShowPhone(discount.id, discount.promoType)}
                showPhoneStyles={{ beforeIcon: <IconPhone16 color="white_100" /> }}
              />
            </SPThemeWrapper>
          ) : null
        }
      />
    </>
  );
}
